<template lang="pug">
  #useradmin
    Header
    v-container(fluid)
      v-row(justify="center" align="center")
        v-col.admin(xs=12)
          AdminAccess

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import AdminAccess from "@/components/AdminAccess/AdminAccess.vue";

export default {
  name: "UserAdmin",
  components: {
    Header,
    AdminAccess
  },
  data() {
    return {
      user: this.$store.state.user
    };
  }
};
</script>
<style lang="scss" scoped>
.admin {
  max-width: 1300px !important;
}
</style>
